import React, { useEffect, useState } from 'react';
import './stock-details.m.css';
import wretch from 'wretch';
import { BQLink } from '../../atoms/bqlink';
import { slugify } from '../../../helpers/utils';
import SvgIcon from '../../atoms/svg-icon';
import { ChevronRightIcon } from '../../atoms/material-icons';

const StockDetails = ({ stock }) => {
  const [stockData, setStockData] = useState({});
  const stockNameSlug = slugify(stock.COMPNAME);

  useEffect(() => {
    getStockValues(stock.STOCKID);
  }, []);

  const getStockValues = stockId => {
    wretch(`/next/feapi/stock/${stockId}/basic-details`)
      .get()
      .json(result => {
        setStockData(result.data);
      })
      .catch(error => error);
  };

  return (
    <BQLink href={`/stock/${stock?.STOCKID}/${stockNameSlug}`} styleName="stock-details">
      <div styleName="stock-up-down-sign">
        {stockData?.bse?.priceChange.toString().includes('-') ? (
          <SvgIcon type="stockDOWN" source="image" height="36" width="36" />
        ) : (
          <SvgIcon type="stockUP" source="image" height="36" width="36" />
        )}
      </div>
      <div styleName="stock-name">
        <span>{stock?.COMPNAME}</span>
        {stockData ? (
          <div styleName="stock-data">
            {stockData?.nse?.priceChange ? (
              <span>
                <span>NSE</span>
                {stockData?.nse?.currentPrice}
              </span>
            ) : null}
            {stockData?.bse?.priceChange && stockData?.nse?.priceChange ? (
              <div styleName="sep-dot" />
            ) : null}
            {stockData?.bse?.priceChange ? (
              <span>
                <span>BSE</span>
                {stockData?.bse?.currentPrice}
              </span>
            ) : null}
          </div>
        ) : null}
      </div>
      <div>
        <ChevronRightIcon />
      </div>
    </BQLink>
  );
};

export default StockDetails;
